<mat-checkbox
  (change)="onCheckboxToggle($event)"
  [checked]="isSelected()"
  [indeterminate]="isIndeterminate()"
>
</mat-checkbox>
